import { render, staticRenderFns } from "./ShoppingList.vue?vue&type=template&id=ddf32ef4&scoped=true&"
import script from "./ShoppingList.vue?vue&type=script&lang=js&"
export * from "./ShoppingList.vue?vue&type=script&lang=js&"
import style0 from "./ShoppingList.vue?vue&type=style&index=0&id=ddf32ef4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddf32ef4",
  null
  
)

export default component.exports